export default __webpack_public_path__ + "static/media/param_speed.baf60b73.svg";